import { render } from "./updatePost.vue?vue&type=template&id=1bbbda63&scoped=true"
import script from "./updatePost.vue?vue&type=script&lang=js"
export * from "./updatePost.vue?vue&type=script&lang=js"

import "./updatePost.vue?vue&type=style&index=0&id=1bbbda63&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bbbda63"]])

export default __exports__